export const formatDate = (date?: Date) => {
    if (!date) return '';
    let day = date.getDate().toString().padStart(2, '0');
    let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    let year = date.getFullYear();
    
    return `${day}.${month}.${year}`;
}